import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Views } from '../TwoFactorAuthentication';
import { TwoFactorAuthenticationMethods, } from '@tradingblock/types';
const StyledVerifiedMethodSelection = styled.div `
  .verified-method-btn {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    border-radius: 10px;
    letter-spacing: unset;
    text-transform: unset;
    min-height: 90px !important;
  }

  .icon-wrapper {
    align-self: flex-start;
    min-width: 22.5px;
  }

  .icon-wrapper i {
    font-size: 1.5rem;
    color: var(--teal);
  }

  .verified-method-info-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1;
    padding: 0 0.5rem 0 0.5rem;
  }

  .verified-method-info-wrapper h5 {
    margin-bottom: 0;
    font-size: 1.15rem;
  }

  .verified-method-info-wrapper p {
    margin-bottom: 0;
    font-weight: normal;
    text-align: left;
    font-size: 0.9rem;
  }

  .icon-wrapper .fa-mobile-alt {
    margin-top: 1.5px;
  }
`;
;
const VerifiedMethodSelection = ({ setCurrentView, verifiedTwoFactorAuthenticationMethodsData, setSelectedVerifiedTwoFactorAuthenticationMethodData, }) => {
    const [sortedVerifiedTwoFactorAuthenticationMethodsData, setSortedVerifiedTwoFactorAuthenticationMethodsData] = useState(verifiedTwoFactorAuthenticationMethodsData);
    useEffect(() => {
        const tempSortedVerifiedTwoFactorAuthenticationMethodsData = [];
        const verifiedSmsTwoFactorAuthenticationMethodData = verifiedTwoFactorAuthenticationMethodsData.find((verifiedTwoFactorAuthenticationMethodData) => verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.sms);
        const verifiedEmailTwoFactorAuthenticationMethodData = verifiedTwoFactorAuthenticationMethodsData.find((verifiedTwoFactorAuthenticationMethodData) => verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.email);
        if (verifiedSmsTwoFactorAuthenticationMethodData) {
            tempSortedVerifiedTwoFactorAuthenticationMethodsData.push(verifiedSmsTwoFactorAuthenticationMethodData);
        }
        if (verifiedEmailTwoFactorAuthenticationMethodData) {
            tempSortedVerifiedTwoFactorAuthenticationMethodsData.push(verifiedEmailTwoFactorAuthenticationMethodData);
        }
        setSortedVerifiedTwoFactorAuthenticationMethodsData(tempSortedVerifiedTwoFactorAuthenticationMethodsData);
    }, [verifiedTwoFactorAuthenticationMethodsData]);
    const handleVerifiedMethodBtnClick = (selectedVerifiedTwoFactorAuthenticationMethodData) => {
        setCurrentView(Views.EnterSecurityCode);
        setSelectedVerifiedTwoFactorAuthenticationMethodData(selectedVerifiedTwoFactorAuthenticationMethodData);
    };
    return (React.createElement(StyledVerifiedMethodSelection, null,
        React.createElement("p", null, "Please select the two-factor authentication (2FA) method you would like to use to complete the login process."),
        sortedVerifiedTwoFactorAuthenticationMethodsData.map((verifiedTwoFactorAuthenticationMethodData) => (React.createElement("button", { key: verifiedTwoFactorAuthenticationMethodData.twoFaType, className: "verified-method-btn btn btn-light btn-block", onClick: () => handleVerifiedMethodBtnClick(verifiedTwoFactorAuthenticationMethodData) },
            React.createElement("div", { className: "icon-wrapper" },
                verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.sms && (React.createElement("i", { className: "fal fa-mobile-alt fa-lg" })),
                verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.email && (React.createElement("i", { className: "fal fa-envelope fa-lg" }))),
            React.createElement("div", { className: "verified-method-info-wrapper" },
                React.createElement("h5", null, (() => {
                    if (verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.sms) {
                        return 'Text';
                    }
                    else if (verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.email) {
                        return 'Email';
                    }
                })()),
                verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.sms && (React.createElement("p", null,
                    "We'll text a security code to: ",
                    verifiedTwoFactorAuthenticationMethodData.phoneNumber,
                    ".")),
                verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.email && (React.createElement("p", null,
                    "We'll email a security code to: ",
                    verifiedTwoFactorAuthenticationMethodData.email,
                    "."))))))));
};
export default VerifiedMethodSelection;
//# sourceMappingURL=VerifiedMethodSelection.js.map